import { useState } from 'react';
import {
  TableRow, TableCell, IconButton, Collapse, Box, Typography, Chip
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import RateDetailsPanel from './RateDetailsPanel';
import { ReservationType, ServiceType } from 'src/utils/constants';

const RateSummaryRow = ({ row }) => {
  const [open, setOpen] = useState(false);

  // Handle row click - only toggle if not clicking on editable fields
  const handleRowClick = (event) => {
    const isEditableClick = event.target.closest('.editable-field-container');

    if (!isEditableClick) {
      setOpen(!open);
    }
  };

  return (
    <>
      <TableRow
        hover
        onClick={handleRowClick}
        sx={{
          cursor: 'pointer',
          borderLeft: open ? '3px solid #1976d2' : '3px solid transparent',
          transition: 'all 0.3s ease',
          '&:hover': { backgroundColor: '#f8f9fa' }
        }}
      >
        <TableCell sx={{ width: '5%', py: 2 }}>
          <IconButton
            size="small"
            sx={{ backgroundColor: open ? '#e3f2fd' : 'transparent' }}
            onClick={(e) => {
              e.stopPropagation();
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
          </IconButton>
        </TableCell>
        <TableCell sx={{ width: '25%', py: 2 }}>
          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
            {row.description}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
            <Chip label={row.type === ReservationType.hotel ? row.baseData.RoomType : row.baseData.ServiceType ? row.baseData.ServiceType : 'Unit'} size="small" sx={{ height: 20, fontSize: '0.7rem' }} />
            <Typography variant="caption" color="text.secondary">{row.item}</Typography>
          </Box>
        </TableCell>
        <TableCell sx={{ width: '12%', py: 2 }}>
          <Typography variant="body2" fontWeight={600}>{row.fromDate}</Typography>
          <Typography variant="caption" color="text.secondary">to {row.toDate}</Typography>
        </TableCell>
        <TableCell align="center" sx={{ width: '10%', py: 2 }}>
          <Typography variant="body2" fontWeight={600}><Chip label={row.chargeType} size="small" sx={{ height: 18, fontSize: '0.6rem' }} /></Typography>
        </TableCell>
        <TableCell align="center" sx={{ width: '12%', py: 2 }}>
          
            {row.type === ReservationType.service && row.baseData.ServiceType === ServiceType.single ? (
              <Typography variant="body2" fontWeight={600}>{row.paxPerUnit} Units</Typography>
            ) : (
              <Typography variant="body2" fontWeight={600}>{row.roomCount} {row.type === ReservationType.hotel ? 'Rooms' : 'Units'}</Typography>
            )}
            {row.type === ReservationType.service && row.baseData.ServiceType === ServiceType.single ? (
              <Typography variant="caption" color="text.secondary">{1} {'pax'}</Typography>
            ) : (
              <Typography variant="caption" color="text.secondary">{row.paxPerUnit} {row.type === ReservationType.hotel ? 'pax per unit' : 'pax'}</Typography>
            )}
        </TableCell>
        <TableCell align="right" sx={{ width: '12%', py: 2 }}>
          <Typography variant="body2" fontWeight={600}><Chip label={row.buyCurrency} size="small" sx={{ height: 18, fontSize: '0.6rem' }} />{row.buyRate}</Typography>
        </TableCell>
        <TableCell align="right" sx={{ width: '12%', py: 2 }}>
          <Typography variant="body2" fontWeight={600}><Chip label={row.sellCurrency} size="small" sx={{ height: 18, fontSize: '0.6rem' }} /> {row.netSellRate}</Typography>
        </TableCell>
        <TableCell align="right" sx={{ width: '12%', py: 2 }}>
          <Typography variant="body1" fontWeight={700} color="success.main">
            <Chip label={row.sellCurrency} size="small" sx={{ height: 18, fontSize: '0.6rem' }} />{row.netSellTotal}
          </Typography>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={8} sx={{ py: 0, borderBottom: open ? '1px solid #e0e0e0' : 'none' }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <RateDetailsPanel row={row} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default RateSummaryRow;